export type EntityPermissionAction = 'view' | 'create' | 'edit' | 'delete'

export function entityPermissionCodename(
  entityKey: string | undefined | null,
  action: EntityPermissionAction,
) {
  const key = entityKey?.trim()
  if (!key) return null
  return `${key}.${action}`
}

export function canEntityPermission(
  can: (codename: string) => boolean,
  entityKey: string | undefined | null,
  action: EntityPermissionAction,
) {
  const codename = entityPermissionCodename(entityKey, action)
  return Boolean(codename && can(codename))
}
